import React, { useState } from "react";
import { Tooltip } from "@mui/material";
import { PhoneEnabled as PhoneEnabledIcon } from "@mui/icons-material";
import { formatPhoneForZoom } from "utils/phone";
import { useDispatch } from "react-redux";
import ZoomPhoneEmbed from "components/ZoomPhoneEmbed/ZoomPhoneEmbed";
import { addLiveCall } from "app/services/patient/nonCompliantPatients";
import { patientApi } from "app/store/patient/api/patientApi";
import { showErrorToast, showSuccessToast } from "utils/toast";
import { useSelector } from "react-redux";
import {
  ZOOM_CALL_DEFAULT_MESSAGE,
  ZOOM_CALL_RECEIVED_STATUS,
  ZOOM_CALL_STATUS_SUMMARY_MAP,
} from "static/constants";
import { getDurationDiff, getFormattedDate } from "utils/date";

const PhoneDisplay = ({ phone, isOptOut = false }) => {
  const [zoomCallPhoneNumber, setZoomCallPhoneNumber] = useState(null);
  const { patientId } = useSelector((state) => state.transmission);
  const [callStartAt, setCallStartAt] = useState();

  const dispatch = useDispatch();

  if (!phone) return "—";

  const handlePhoneCall = () => {
    const isMac = navigator.userAgent.includes("Mac");
    if (isMac) {
      // automatically open zoom on macOS
      window.open("zoommtg://zoom.us", "_blank");
    }

    const formattedPhone = formatPhoneForZoom(phone);
    setZoomCallPhoneNumber(null);
    setTimeout(() => {
      setZoomCallPhoneNumber(formattedPhone);
    }, 0);
  };

  const handleCallEnd = async (callInfo) => {
    try {
      const { callId, callStatus, callEndAt } = callInfo;
      const status = ZOOM_CALL_RECEIVED_STATUS.includes(callStatus)
        ? "received"
        : "failed";

      const callDuration =
        status === "received" ? getDurationDiff(callStartAt, callEndAt) : null;

      const payload = {
        status,
        zoom_call_id: callId,
        patientId,
        duration: callDuration,
        call_date: getFormattedDate(callEndAt),
        summary:
          ZOOM_CALL_STATUS_SUMMARY_MAP[callStatus] || ZOOM_CALL_DEFAULT_MESSAGE,
      };

      const response = await addLiveCall(payload);

      if (!response?.error) {
        showSuccessToast(response?.message);
        dispatch(patientApi.util.invalidateTags(["patientReminderHistory"]));
      }
    } catch (error) {
      showErrorToast(error.message);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        whiteSpace: "nowrap",
      }}
    >
      <span style={{ overflowWrap: "normal" }}>{phone}</span>

      {!isOptOut && (
        <Tooltip title="Call via Zoom (Zoom Workspace required)" arrow>
          <PhoneEnabledIcon
            onClick={handlePhoneCall}
            sx={{
              color: "#94BA33",
              width: 32,
              height: 32,
              cursor: "pointer",
              p: 0.5,
              borderRadius: "50%",
              transition: "background-color 0.2s",
              "&:hover": { backgroundColor: "#f0f0f0" },
            }}
          />
        </Tooltip>
      )}

      {!isOptOut && zoomCallPhoneNumber && (
        <ZoomPhoneEmbed
          handleCallEnd={handleCallEnd}
          phoneNumber={zoomCallPhoneNumber}
          handleCallStart={(startAt) => setCallStartAt(startAt)}
        />
      )}
    </div>
  );
};

export default PhoneDisplay;
